// extracted by mini-css-extract-plugin
export default {"loader":"SpinnerButton_loader__t5nQQ","relative":"SpinnerButton_relative__eeS2O","hideText":"SpinnerButton_hideText__+exPb"};